import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/pages/payment.css';
import Mascot from '../components/Mascot';

/**
 * PaymentCancel.js
 *
 * Stripe redirects here when the user closes the hosted checkout page.
 * Razorpay fires ondismiss() which keeps the user on the landing page,
 * so this page is only ever reached via Stripe's cancel_url.
 */
function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="payment-page">
      <div className="payment-say">
        <Mascot size={40} />
        <div className="payment-say__bubble"><b>Michii says</b><span>Nothing changed. Your guides are all still here.</span></div>
      </div>
      <div className="payment-card payment-card--cancel m-sheet">

        <h1 className="payment-heading payment-heading--cancel">Payment cancelled</h1>
        <p className="payment-sub payment-sub--cancel">
          No worries — you haven't been charged. Your guides are untouched.
        </p>

        <div className="payment-nudge">
          <p className="payment-nudge-title">Still thinking about it?</p>
          <p className="payment-nudge-desc">
            You can upgrade any time from the pricing section. The plan activates instantly.
          </p>
        </div>

        <button className="lp-btn payment-btn" onClick={() => navigate('/#pricing')}>
          Back to pricing
        </button>
        <button className="lp-tlink payment-btn--secondary" onClick={() => navigate('/')}>
          Back to Michii
        </button>

      </div>
    </div>
  );
}

export default PaymentCancel;